import CLIENT_ASSORTMENTS from './clientAssortment.graphql'

export default CLIENT_ASSORTMENTS
